import React from 'react';

function ChatbotHeader({carNumber}) {
    return (
        <>
        {/* Header */}
        <div className="relative flex items-center justify-center bg-white border-b h-[54px]">
          <button className="absolute p-2 left-5" onClick={() => window.history.back()}>
            <svg className="w-6 h-6" fill="none" strokeWidth="2" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
          </button>
          <h1 className="text-base font-medium">다이렉트 보상</h1>
          <span className="bg-[#F0F3F7] w-[79px] h-[28px] rounded-md text-[13px] flex justify-center items-center absolute right-5">
            {carNumber}
          </span>
        </div>
        <div className='h-1 bg-[#E4E7EC] w-full flex justify-center'>
          <p className='bg-[#313A4C] h-1 w-full'></p>
          <p className="bg-[#E4E7EC] h-1 w-full"></p>
          <p className="bg-[#E4E7EC] h-1 w-full"></p>
          <p className="bg-[#E4E7EC] h-1 w-full"></p>
          <p className="bg-[#E4E7EC] h-1 w-full"></p>
          <p className="bg-[#E4E7EC] h-1 w-full"></p>
          <p className="bg-[#E4E7EC] h-1 w-full"></p>
        </div>
        </>
    );
}

export default ChatbotHeader;
